export const combine = <TArgs extends unknown[]>(...fns: ((...args: TArgs) => void)[]) => {
    return (...args: TArgs) => {
        fns.filter(Boolean).forEach((fn) => fn(...args));
    };
};
